

















import {
  defineComponent,
  PropType,
  ref,
  watch,
  vue3Model
} from '~/utils/nuxt3-migration'
import CStar from '~/components/shared/configurable/rating/CStar.vue'

export default defineComponent({
  model: vue3Model,
  components: { CStar },
  props: {
    modelValue: {
      type: Number,
      required: false
    },
    maxRating: {
      type: Number,
      default: 5
    },
    size: {
      type: Number,
      default: 20
    },
    static: {
      type: Boolean,
      default: false
    },
    colorClass: {
      type: String,
      default: 'tw-text-orange-500'
    },
    tooltips: {
      type: Object as PropType<Record<number, string>>,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const tempRating = ref(0)
    const rating = ref(props.modelValue || 0)

    watch(
      () => props.modelValue,
      newValue => {
        rating.value = newValue || 0
      }
    )

    function getStarIconStyle(r: number) {
      if (tempRating.value) {
        return tempRating.value >= r ? 'full' : 'empty'
      }

      if (
        rating.value + 1 >= r &&
        rating.value + 1 < r + 1 &&
        rating.value % 1 >= 0.5
      ) {
        return 'half'
      }

      return rating.value >= r ? 'full' : 'empty'
    }

    function setTempRating(v: number) {
      tempRating.value = v
    }

    function setRating(r: number) {
      rating.value = r

      emit('change', r)
      emit('update:modelValue', r)
    }

    return {
      getStarIconStyle,
      tempRating,
      rating,
      setTempRating,
      setRating
    }
  }
})
